const HIDDEN_EMAIL_DOMAINS = ['ramco.io'];

/**
 * Internal/test accounts (e.g. @ramco.io) that should never surface in
 * org member lists or counts.
 */
export const isHiddenEmail = email => {
    if (!email) return false;
    const domain = email.toLowerCase().split('@')[1];
    return HIDDEN_EMAIL_DOMAINS.includes(domain);
};

export const excludeHiddenEmails = (list = []) =>
    (list || []).filter(item => !isHiddenEmail(item?.email));

const STAFF_EMAIL_DOMAINS = ['ramco.io', 'ramcoprotective.com'];

/**
 * Sage staff addresses. The API leaves them out of an org's `seats.manager` count and only a super admin adds them to a
 * team (`isStaffEmail` in sage-nest-api, the same rule: the part after the last `@` is exactly one of the domains,
 * whatever the casing or surrounding spaces; no subdomains).
 */
export const isStaffEmail = email => {
    if (typeof email !== 'string') return false;
    const normalized = email.trim().toLowerCase();
    const at = normalized.lastIndexOf('@');
    return at > 0 && STAFF_EMAIL_DOMAINS.includes(normalized.slice(at + 1));
};
